import { render } from "./AddPayment.vue?vue&type=template&id=8febead6&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"

import "./AddPayment.vue?vue&type=style&index=0&id=8febead6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8febead6"]])

export default __exports__